import { CartI } from "../interfaces/cart.interface";

export const state: CartI = {
  cart_items: 0,
  cart_order_items: null,
  products_bonuses: [],
  order_items: [],
};
